module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/edit-brand/edit-brand.component.scss
// module id = ./src/app/edit-brand/edit-brand.component.scss
// module chunks = main